// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://cyvzwyrrminydukcdvdg.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImN5dnp3eXJybWlueWR1a2NkdmRnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzk5MDk2NTEsImV4cCI6MjA1NTQ4NTY1MX0.Ukh5Fz5q-sGUOmk7LMMRF1BZQE58K0w93msEKqeH89w";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);